import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-lg" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3 col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "Filtre", -1)
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "container mt-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = ["onKeypress"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-end" }, "Nulstil filtre", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = {
  key: 0,
  class: "mt-3 ms-2"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-3 ms-2"
}
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = {
  key: 2,
  class: "row mt-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Indlæser...")
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 3,
  class: "row"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "row border-bottom border-dark" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "col-3" }, "Figur"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-9" }, "Klodser")
], -1)
const _hoisted_22 = { class: "col-3 mt-2" }
const _hoisted_23 = { class: "col-9" }

import { useQuery, useResult } from "@vue/apollo-composable";
import Pagination from "@/components/base/Pagination.vue";
import { computed, onMounted, ref, Ref, watch } from "vue";
import Klodstabel from "@/components/base/Klodstabel.vue";
import Lokationsfilter from "@/components/Lokationsfilter.vue";
import MinifigurElement from "@/components/base/MinifigurElement.vue";
import gql from "graphql-tag";
import { useAuth0 } from "@auth0/auth0-vue";
import { onBeforeRouteLeave } from "vue-router";

interface LokationVariable {
  lokationer: string[] | undefined;
}
interface FigurVariable extends LokationVariable {
  soegNavn: string | undefined;
}
interface Filter {
  soegetekst: string;
  lokationer: string[];
  side: number;
  max: number;
}

interface Optaelling {
  antalFigurer: { count: number };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LegoMinifigs',
  setup(__props) {

function defaultFilter(): Filter {
  return {
    soegetekst: "",
    lokationer: [],
    side: 1,
    max: 20
  };
}

const filternavn = "legominifigs.filter";
const filter: Ref<Filter> = ref(defaultFilter());
const searchValue: Ref<string> = ref("");
const accessToken: Ref<string> = ref("");

function figurParameterBlok() {
  let figurOpslagVariable = "";

  if (filter.value.soegetekst) {
    figurOpslagVariable += `$soegNavn: String\n`;
  }

  if (filter.value.lokationer.length > 0) {
    figurOpslagVariable += `$lokationer: [String!]\n`;
  }
  return figurOpslagVariable;
}

function figurWhereBlok() {
  let figurOpslagParameterWhereAndBlok = ``;

  if (filter.value.soegetekst) {
    figurOpslagParameterWhereAndBlok += `{ OR: [
      { navn_MATCHES: $soegNavn }
      { nummer: $soegNavn }
    ]}\n`;
  }

  if (filter.value.lokationer.length > 0) {
    figurOpslagParameterWhereAndBlok += `{
      setsIndeholder_SOME: {
        placeretLokations_SOME: { navn_IN: $lokationer }
      }
    }\n`;
  }

  return `where: {
    AND: [
      ${figurOpslagParameterWhereAndBlok}
    ]}
  `;
}

function gemFiltre() {
  localStorage.setItem(filternavn, JSON.stringify(filter.value));
}
function nulstilAlleFiltre() {
  filter.value = defaultFilter();
  searchValue.value = "";
  gemFiltre();
}

const { result: figurResult, loading: figurLoading } = useQuery(
  () => {
    const figurOpslagVariable = figurParameterBlok();
    const figurOpslagParameterWhereAndBlok = figurWhereBlok();

    const figurUdtryk = `query figurer(
  ${figurOpslagVariable}
  $offset: Int
  $max: Int
) {
  figurer: figurs(
    ${figurOpslagParameterWhereAndBlok}
    options: { offset: $offset, limit: $max }
  ) {
    __typename
    uuid
    nummer
    navn
    katalognummer
    url
    antalFigurer
    bestaarAfKlods {
      __typename
      uuid
      navn
      url
      beregnetAntal
      difference
      erDelDels {
        __typename
        nummer
        navn
        harKategoriKategoris {
          navn
        }
      }
      harFarvenFarves {
        __typename
        navn
        id
      }
    }
  }
}
`;
    return gql(figurUdtryk);
  },
  () => {
    const variables: FigurVariable = {
      lokationer: undefined,
      soegNavn: undefined
    };
    if (filter.value.soegetekst) {
      variables.soegNavn = filter.value.soegetekst;
    }
    if (filter.value.lokationer.length > 0) {
      variables.lokationer = filter.value.lokationer;
    }
    return {
      ...variables,
      max: filter.value.max,
      offset: (filter.value.side - 1) * filter.value.max
    };
  }
);

const figurer = useResult(figurResult, [], data => data.figurer);

const { result: antalFigurResult, loading: taeller } = useQuery<Optaelling>(
  () => {
    const figurOpslagVariable = figurParameterBlok();
    const figurOpslagParameterWhereAndBlok = figurWhereBlok();
    let figurHoved = `query antalFigurer`;
    if (figurOpslagVariable.length > 0) {
      figurHoved += `(
      ${figurOpslagVariable}
      )`;
    }
    const figurUdtryk = `${figurHoved} {
  antalFigurer:  figursAggregate(
    ${figurOpslagParameterWhereAndBlok}
  ) {
    count
  }
}
`;
    return gql(figurUdtryk);
  },
  () => {
    const variables: FigurVariable = {
      lokationer: undefined,
      soegNavn: undefined
    };
    if (filter.value.soegetekst) {
      variables.soegNavn = filter.value.soegetekst;
    }
    if (filter.value.lokationer.length > 0) {
      variables.lokationer = filter.value.lokationer;
    }
    return {
      ...variables
    };
  }
);

const antalFigurer = useResult(
  antalFigurResult,
  -1,
  data => data.antalFigurer.count
);

const antal = computed(() => {
  return taeller.value ? -1 : antalFigurer.value;
});

const altIndlaest = computed(() => {
  return antal.value <= filter.value.max;
});

const antalSider = computed(() => {
  if (taeller.value) {
    return 0;
  } else {
    return Math.ceil(antalFigurer.value / filter.value.max);
  }
});

const start = computed(() => {
  if (taeller.value) {
    return undefined;
  } else {
    return (filter.value.side - 1) * filter.value.max + 1;
  }
});

const slut = computed(() => {
  if (taeller.value) {
    return undefined;
  } else {
    return Math.min(filter.value.side * filter.value.max, antalFigurer.value);
  }
});

function defaultMiniFig(e) {
  e.target.src = "http://localhost:8080/minifig.png";
}
function opdaterLokationer(valgteLokationer: string[]) {
  filter.value.lokationer = valgteLokationer;
}

function soeg() {
  filter.value.soegetekst = searchValue.value;
}
function onEnter(event: KeyboardEvent) {
  soeg();
}
function sideskift(side: number): void {
  filter.value.side = side;
}

onMounted(async () => {
  const value = localStorage.getItem(filternavn);
  if (value) {
    filter.value = JSON.parse(value);
    searchValue.value = filter.value.soegetekst;
  }
  const tokenKey = "accesstoken";
  await useAuth0()
    .getAccessTokenSilently()
    .then(response => {
      accessToken.value = response;
      localStorage.setItem(tokenKey, response);
    })
    .catch(error => {
      console.error("Fejl ved hent af token: " + error);
      localStorage.removeItem(tokenKey);
      accessToken.value = "";
    });
});

onBeforeRouteLeave(() => {
  gemFiltre();
});

watch(searchValue, tekst => {
  if (tekst?.length == 0) soeg("");
});

watch(antalSider, antal => {
  if (antal < filter.value.side) {
    filter.value.side = Math.max(antal, 1);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Lokationsfilter, {
            lokationer: filter.value.lokationer,
            onUpdate: opdaterLokationer
          }, null, 8, ["lokationer"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control me-2",
                type: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
                onKeypress: _withKeys(onEnter, ["enter"]),
                placeholder: "Figurnummer eller titel..."
              }, null, 40, _hoisted_10), [
                [_vModelText, searchValue.value]
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: soeg,
                type: "button"
              }, " Søg ")
            ])
          ]),
          _createElementVNode("div", { class: "row d-flex flex-row-reverse" }, [
            _createElementVNode("div", { class: "text-end col-2 mt-1" }, [
              _createElementVNode("button", {
                class: "btn btn-link btn-sm",
                onClick: nulstilAlleFiltre
              }, _hoisted_12)
            ])
          ]),
          (!_unref(taeller))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (!_unref(altIndlaest))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                      _createTextVNode(" Figur " + _toDisplayString(_unref(start)), 1),
                      _withDirectives(_createElementVNode("span", null, "-" + _toDisplayString(_unref(slut)), 513), [
                        [_vShow, _unref(start) < _unref(slut)]
                      ]),
                      _createTextVNode(" (ud af " + _toDisplayString(_unref(antal)) + ") ", 1),
                      _createVNode(Pagination, {
                        "antal-sider": _unref(antalSider),
                        "per-side": filter.value.max,
                        side: filter.value.side,
                        onSideskift: _cache[1] || (_cache[1] = side => sideskift(side))
                      }, null, 8, ["antal-sider", "per-side", "side"])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_15, "Fundet " + _toDisplayString(_unref(antal)), 1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, "   ")),
          (_unref(figurLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(figurer), (figur) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row border-bottom border-2 figurraekke",
                    key: figur.uuid
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(MinifigurElement, {
                        uuid: figur.uuid
                      }, null, 8, ["uuid"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(Klodstabel, {
                        "minifigur-uuid": figur.uuid,
                        "vis-antal-i-figur": true
                      }, null, 8, ["minifigur-uuid"])
                    ])
                  ]))
                }), 128))
              ]))
        ])
      ])
    ])
  ]))
}
}

})